export class ReportLayers {
    http;
    constructor(http) {
        this.http = http;
    }
    getReportLayers() {
        return this.http.get(`/api/report_layers`).json();
    }
}
